<div class="mb-4"><span class="font-semibold">{{ providerAccount.accountName }}</span></div>

<p-panel header="Verify Provider Information">
  <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned">
    <div class="col-span-12 lg:col-span-6">
      <div class="field">
        <label>NPI:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.practiceNpinumber }}</div>
        </div>
      </div>
      <div class="field">
        <label>Tax ID:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.practiceTaxId }}</div>
        </div>
      </div>
      @if (isGoldCardVisible) {
        <div class="field">
          <label data-test-id="gold-card-provider-label">Gold Card Provider:</label>
          <div class="p-field-value">
            <div class="readonly-field">
              <p-checkbox data-test-id="gold-card-provider-checkbox" [ngModel]="isGoldCardProvider" [binary]="true"
              [disabled]="true"></p-checkbox>
            </div>
          </div>
        </div>
      }
      @if (isGoldCardProvider) {
        <div class="field">
          <label data-test-id="gold-card-auth-type-label">Gold Card Auth Type:</label>
          <div class="p-field-value">
            <div class="readonly-field">{{ goldCardAuthorizationType | emptyPlaceholder  }}</div>
          </div>
        </div>
      }
    </div>
    <div class="col-span-12 lg:col-span-6">
      <div class="field">
        <label>Street:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.physicalStreet }}</div>
        </div>
      </div>
      <div class="field">
        <label>City:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.physicalCity }}</div>
        </div>
      </div>
      <div class="field">
        <label>State:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.physicalState }}</div>
        </div>
      </div>
      <div class="field">
        <label>ZIP Code:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.physicalZip | zipCode }}</div>
        </div>
      </div>
      <div class="field">
        <label>Phone:</label>
        <div class="p-field-value">
          <div class="readonly-field">{{ providerAccount.phone | phoneNumber }}</div>
        </div>
      </div>
    </div>
  </div>
</p-panel>
